<template>
  <div>
    <header id="header" class="header fixed-top d-flex align-items-center">
      <div class="d-flex align-items-center justify-content-between">
        <a href="/admin" class="logo d-flex align-items-center">
          <span class="d-lg-block">
            <img src="../assets/img/logo.png" height="120" />
          </span>
        </a>
        <div
          class="title-name"
          style="color:#283145;font-weight: 600;font-size:1.2rem"
        >
          {{ $route.meta.title }}
        </div>
        <i class="bi bi-list toggle-sidebar-btn" />
      </div>

      <nav
        class="header-nav ms-auto d-flex"
        style="margin:20px; "
        v-if="userInfo"
      >
        <div class="locale-changer" style="margin-right: 15px">
          {{ $t("languageTitle") }} :
          <select
            v-model="$i18n.locale"
            class=""
            style="border: 1px solid #d0d0d0"
          >
            <option
              v-for="locale in $i18n.availableLocales"
              :key="`locale-${locale}`"
              :value="locale"
              >{{ locale.toUpperCase()}}</option
            >
          </select>
        </div>



        <div class="locale-changer" style="margin-right: 15px">
          version
          <select
           @change="handleChangeVersion"
            v-model="version"
            class=""
            style="border: 1px solid #d0d0d0"
          >
            <option
          
              :key="`1`"
               value="Full"
              >Full</option
            >
            <option
          
          :key="`2`"
           value="Short"
          >Short</option
        >

          </select>
        </div>





        <div
          class="d-flex text-center dropdown align-items-center dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          aria-haspopup="true"
          aria-expanded="false"
          @click="toggleDropdown"
        >
          <div class="d-flex ">
            <img
              v-if="userInfo.profileImage"
              :src="userInfo.profileImage"
              class="m-auto me-2"
              style="width: ;100%; height: 20px"
            />
            <img
              v-else
              src="../assets/img/avatar.png"
              width="30"
              class="me-2 rounded-circle "
            />
            <div v-if="userInfo" class="m-auto me-2">{{ userInfo.name }}</div>
          </div>
          <div
            class="dropdown-menu"
            :class="{ show: showDropdown }"
            aria-labelledby="dropdownMenuButton"
          >
            <button
              type="submit"
              class="btn  "
              style="padding:0 20px;margin:0px"
              @click="signout"
            >
              <svg
                class="me-1"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="12" fill="#256497" />
                <path
                  d="M7.33333 7.33333H11.3333C11.7 7.33333 12 7.03333 12 6.66667C12 6.3 11.7 6 11.3333 6H7.33333C6.6 6 6 6.6 6 7.33333V16.6667C6 17.4 6.6 18 7.33333 18H11.3333C11.7 18 12 17.7 12 17.3333C12 16.9667 11.7 16.6667 11.3333 16.6667H7.33333V7.33333Z"
                  fill="white"
                />
                <path
                  d="M17.7667 11.7667L15.9067 9.90667C15.8603 9.85903 15.8008 9.82632 15.7357 9.81271C15.6706 9.7991 15.603 9.80522 15.5414 9.83028C15.4799 9.85533 15.4272 9.89819 15.3901 9.95337C15.353 10.0085 15.3333 10.0735 15.3333 10.14V11.3333H10.6667C10.3 11.3333 10 11.6333 10 12C10 12.3667 10.3 12.6667 10.6667 12.6667H15.3333V13.86C15.3333 14.16 15.6933 14.3067 15.9 14.0933L17.76 12.2333C17.8933 12.1067 17.8933 11.8933 17.7667 11.7667Z"
                  fill="white"
                />
              </svg>
              Log out
            </button>
          </div>
        </div>
      </nav>
    </header>
    <!-- ======= Sidebar ======= -->
    <aside
      id="sidebar"
      ref="menuRef"
      class="sidebar"
      :class="{ sidebarOpen: isSidebarOpen, sidebarClose: !isSidebarOpen }"
      style="top:0px;margin-top: 3.5em;"
    >
      <ul class="list-unstyled ps-0 mt-3">
        <li
          class="mb-1"
          v-if="isAdminOrUser"
        >
          <button
            class="btn btn-toggle align-items-center rounded text-white"
            data-bs-toggle="collapse"
            data-bs-target="#home-collapse"
            aria-expanded="true"
          >
            <svg
              width="20"
              height="14"
              viewBox="0 0 20 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5 7C14.8283 7 15.1534 6.93534 15.4567 6.8097C15.76 6.68406 16.0356 6.49991 16.2678 6.26777C16.4999 6.03562 16.6841 5.76002 16.8097 5.45671C16.9353 5.15339 17 4.8283 17 4.5C17 3.83696 16.7366 3.20107 16.2678 2.73223C15.7989 2.26339 15.163 2 14.5 2C13.837 2 13.2011 2.26339 12.7322 2.73223C12.2634 3.20107 12 3.83696 12 4.5C12 4.8283 12.0647 5.15339 12.1903 5.45671C12.3159 5.76002 12.5001 6.03562 12.7322 6.26777C13.2011 6.73661 13.837 7 14.5 7ZM7 6C7.79565 6 8.55871 5.68393 9.12132 5.12132C9.68393 4.55871 10 3.79565 10 3C10 2.20435 9.68393 1.44129 9.12132 0.87868C8.55871 0.316071 7.79565 0 7 0C6.20435 0 5.44129 0.316071 4.87868 0.87868C4.31607 1.44129 4 2.20435 4 3C4 3.79565 4.31607 4.55871 4.87868 5.12132C5.44129 5.68393 6.20435 6 7 6ZM14.5 9C12.67 9 9 9.92 9 11.75V14H20V11.75C20 9.92 16.33 9 14.5 9ZM7 8C4.67 8 0 9.17 0 11.5V14H7V11.75C7 10.9 7.33 9.41 9.37 8.28C8.5 8.1 7.66 8 7 8Z"
                fill="white"
              />
            </svg>
            <span class="" style="margin-left:5px">User Administration</span>
          </button>
          <div class="collapse show" id="home-collapse" style="">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <li
                v-if="userRole === 'admin'"
                :class="{
                  'menu-active':
                    $route.path === '/admin' || $route.path === '/create-admin',
                }"
                @click="handleClickMenu('admin')"
              >
                <div class="text-white ml40">Super Admin</div>
              </li>
              <li
                :class="{
                  'menu-active':
                    $route.path === '/user' || $route.path === '/create-user',
                }"
                @click="handleClickMenu('user')"
              >
                <div class="text-white ml40">DDI Admin</div>
              </li>
              <li
                :class="{
                  'menu-active':
                    $route.path === '/customer' ||
                    $route.path === '/create-customer',
                }"
                @click="handleClickMenu('customer')"
              >
                <div class="text-white ml40">Trivision User</div>
              </li>
            </ul>
          </div>
        </li>
        <li class="mb-1">
          <button
            class="btn btn-toggle align-items-center rounded collapsed text-white"
            data-bs-toggle="collapse"
            data-bs-target="#dashboard-collapse"
            aria-expanded="false"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 5V9H21V5M9 19H21V15H9M9 14H21V10H9M4 9H8V5H4M4 19H8V15H4M4 14H8V10H4V14Z"
                fill="white"
              />
            </svg>
            <span>Run Session</span>
          </button>
          <div class="collapse show" id="dashboard-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <li
                v-if="isAdminOrUser"
                :class="{
                  'menu-active':
                    $route.path === '/team-configuration' ||
                    $route.path === '/create-session',
                }"
                @click="handleClickMenu('team-configuration')"
              >
                <div class="text-white ml40">Team Configuration</div>
              </li>
              <li
                :class="{
                  'menu-active':
                    $route.path === '/data-entry' ||
                    $route.path === '/create-data-entry',
                }"
                @click="redirectDataEntry"
              >
                <div class="text-white ml40">Data Entry</div>
              </li>
            </ul>
          </div>
        </li>
        <li class="mb-1">
          <button
            class="btn btn-toggle text-white align-items-center rounded collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#orders-collapse"
            aria-expanded="false"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 15H9V11H7.5V12.25H6V13.75H7.5V15ZM10 13.75H18V12.25H10V13.75ZM15 11H16.5V9.75H18V8.25H16.5V7H15V11ZM6 9.75H14V8.25H6V9.75ZM8 21V19H4C3.45 19 2.97933 18.8043 2.588 18.413C2.196 18.021 2 17.55 2 17V5C2 4.45 2.196 3.979 2.588 3.587C2.97933 3.19567 3.45 3 4 3H20C20.55 3 21.021 3.19567 21.413 3.587C21.8043 3.979 22 4.45 22 5V17C22 17.55 21.8043 18.021 21.413 18.413C21.021 18.8043 20.55 19 20 19H16V21H8Z"
                fill="white"
              />
            </svg>
            <span> Utilities </span>
          </button>
          <div class="collapse show" id="orders-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <li
                :class="{
                  'menu-active':
                    $route.path === '/utilities' || $route.name === 'review',
                }"
                @click="redirectUtilities"
              >
                <div class="text-white ml40">Review Session</div>
              </li>
            </ul>
          </div>
        </li>





        <li class="mb-1">
          <button
            class="btn btn-toggle text-white align-items-center rounded collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#orders-collapse"
            aria-expanded="false"
          >
          

          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32" height="32" viewBox="0,0,256,256">
<g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(4,4)"><path d="M29.05469,10c-1.339,0 -2.48298,0.9642 -2.70898,2.2832l-0.58203,3.38086c-0.306,0.117 -0.6112,0.23809 -0.9082,0.37109l-2.79687,-1.97656c-1.228,-0.849 -2.67525,-0.53827 -3.53125,0.30273l-4.16602,4.16406c-0.947,0.947 -1.07278,2.43725 -0.30078,3.53125l1.97461,2.79883c-0.134,0.297 -0.25409,0.60025 -0.37109,0.90625l-3.38086,0.58203c-1.32,0.227 -2.2832,1.37194 -2.2832,2.71094v5.89062c0,1.339 0.9642,2.48298 2.2832,2.70898l3.38086,0.58203c0.117,0.306 0.23809,0.6112 0.37109,0.9082l-1.97656,2.79688c-0.772,1.093 -0.64427,2.58425 0.30273,3.53125l4.16406,4.16602c1.084,1.06 2.59925,0.97578 3.53125,0.30078l2.79883,-1.97461c0.297,0.134 0.60025,0.25409 0.90625,0.37109l0.58203,3.38086c0.227,1.32 1.37194,2.2832 2.71094,2.2832h5.89062c1.339,0 2.48298,-0.9642 2.70898,-2.2832l0.58203,-3.38086c0.306,-0.117 0.6112,-0.23809 0.9082,-0.37109l2.79688,1.97656c0.825,0.608 2.40225,0.82727 3.53125,-0.30273l4.16602,-4.16406c0.947,-0.947 1.07278,-2.43725 0.30078,-3.53125l-1.97461,-2.79883c0.134,-0.297 0.25409,-0.60025 0.37109,-0.90625l3.38086,-0.58203c1.32,-0.227 2.2832,-1.37194 2.2832,-2.71094v-5.89062c0,-1.339 -0.9642,-2.48298 -2.2832,-2.70898l-3.38086,-0.58203c-0.117,-0.306 -0.23809,-0.6112 -0.37109,-0.9082l1.97656,-2.79687c0.772,-1.093 0.64427,-2.58425 -0.30273,-3.53125l-4.16406,-4.16602c-1.057,-1.032 -2.52225,-1.00978 -3.53125,-0.30078l-2.79883,1.97461c-0.297,-0.134 -0.60025,-0.25409 -0.90625,-0.37109l-0.58203,-3.38086c-0.227,-1.32 -1.37194,-2.2832 -2.71094,-2.2832zM30.21484,14h3.57227c0.061,0 0.11305,0.04352 0.12305,0.10352l0.77148,4.48633c1.768,0.635 3.4232,1.3043 4.9082,2.0293l3.71289,-2.62305c0.05,-0.035 0.11911,-0.02933 0.16211,0.01367l2.52539,2.52734c0.043,0.043 0.05062,0.11016 0.01563,0.16016l-2.625,3.71484c0.759,1.605 1.4433,3.23725 2.0293,4.90625l4.48633,0.77344c0.06,0.01 0.10352,0.06205 0.10352,0.12305v3.57227c0,0.061 -0.04447,0.11305 -0.10547,0.12305l-4.48437,0.77148c-0.585,1.669 -1.2613,3.3042 -2.0293,4.9082l2.625,3.71484c0.035,0.05 0.02737,0.11716 -0.01562,0.16016l-2.52539,2.52734c-0.043,0.043 -0.11211,0.04867 -0.16211,0.01367l-3.71289,-2.62305c-1.64,0.771 -3.2762,1.4463 -4.9082,2.0293l-0.77344,4.48438c-0.01,0.06 -0.06205,0.10352 -0.12305,0.10352h-3.57227c-0.061,0 -0.11305,-0.04447 -0.12305,-0.10547l-0.77148,-4.48437c-1.609,-0.559 -3.2432,-1.2253 -4.9082,-2.0293l-3.71484,2.625c-0.05,0.035 -0.11716,0.02737 -0.16016,-0.01562l-2.52734,-2.52539c-0.043,-0.043 -0.04867,-0.11211 -0.01367,-0.16211l2.62305,-3.71289c-0.779,-1.665 -1.4553,-3.3012 -2.0293,-4.9082l-4.48437,-0.77344c-0.06,-0.01 -0.10352,-0.06205 -0.10352,-0.12305v-3.57227c0,-0.061 0.04352,-0.11205 0.10352,-0.12305l4.48633,-0.77344c0.581,-1.636 1.2473,-3.27125 2.0293,-4.90625l-2.625,-3.71484c-0.035,-0.05 -0.02737,-0.11716 0.01563,-0.16016l2.52539,-2.52734c0.043,-0.043 0.11211,-0.04867 0.16211,-0.01367l3.71289,2.62305c1.548,-0.743 3.1892,-1.4153 4.9082,-2.0293l0.77344,-4.48437c0.01,-0.06 0.06205,-0.10352 0.12305,-0.10352zM32,23c-4.971,0 -9,4.029 -9,9c0,4.971 4.029,9 9,9c4.971,0 9,-4.029 9,-9c0,-4.971 -4.029,-9 -9,-9zM32,27c2.761,0 5,2.239 5,5c0,2.761 -2.239,5 -5,5c-2.761,0 -5,-2.239 -5,-5c0,-2.761 2.239,-5 5,-5z"></path></g></g>
</svg>

            <span> Setting </span>
          </button>
          <div class="collapse show" id="orders-collapse">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <li
                :class="{
                  'menu-active':
                    $route.path === '/setting-en' ,
                }"
                @click="$router.push({ path: '/setting-en' })"
              >
                <div class="text-white ml40">Language EN</div>
              </li>



              <li
                :class="{
                  'menu-active':
                    $route.path === '/setting-th' ,
                }"
                @click="$router.push({ path: '/setting-th' })"
              >
                <div class="text-white ml40">Language TH</div>
              </li>



            </ul>
          </div>
        </li>




      </ul>
    </aside>
    <main>
      <div class="menu-mobile">
        <div ref="menuClick">
          <font-awesome-icon
            class="pointer"
            icon="fa-solid fa-bars  "
            @click="openMenu()"
          />
        </div>
      </div>
      <slot> </slot>
      <div class="footer">
        <img
          src="../assets/img/ddi1.png"
          width="80"
          style="z-index: 1000;  right: 20px;bottom: 20px;"
        />
      </div>
    </main>
  </div>
</template>

<script>
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import firebase from "firebase";

export default {
  name: "LayoutSlideBar",
  data() {
    return {
      userInfo: null,
      isLoggedIn: false,
      showDropdown: false,
      isSidebarOpen: false,
      version: 'Full'
    };
  },
  computed: {
    userRole() {
      return this.userInfo?.role || "";
    },
    isAdminOrUser() {
      return this.userRole === "admin" || this.userRole === "user";
    },
  },
  mounted() {



    // Hide the dropdown menu when the user clicks outside of it
    document.addEventListener("click", (event) => {
      if (!this.$el.contains(event.target)) {
        this.showDropdown = false;
      }
    });

    document.addEventListener("click", this.closeMenu);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeMenu);
  },
  async created() {

    const versionLanguage = localStorage.getItem('version');
    if (!versionLanguage) {
       localStorage.setItem('version', 'Full'); // Store selected version in localStorage
    } else {
      this.version = versionLanguage;
    }

    const userId = localStorage.getItem("userInfo");

    if (userId) {
      const info = JSON.parse(userId);
      this.userInfo = info;
    }
  },
  methods: {
    handleChangeVersion(val) {
      console.log(val.target.value);
      localStorage.setItem('version', val.target.value);
    },
    redirectDataEntry() {
      const result = localStorage.getItem("teamConfig");
      if (result) {
        this.$router.push({
          path: "/create-data-entry",
          query: { id: result },
        });
      } else {
        this.$router.push({ path: "/data-entry" });
      }
    },
    redirectUtilities() {
      if (this.$route.path === "/create-data-entry") {
        this.handleClickMenu("utilities");
        return;
      }

      const result = localStorage.getItem("teamConfig");
      if (result) {
        this.$router.push({
          path: "/review",
          query: { id: result, view: true, path: "reviewSession" },
        });
      } else {
        this.$router.push({ path: "/utilities" });
      }
    },
    closeMenu(e) {
      if (!this.$refs.menuClick.contains(e.target)) {
        this.isSidebarOpen = false;
      }
    },
    openMenu(event) {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    signout() {
      this.userInfo = null;
      localStorage.removeItem("userInfo");
      firebase
        .auth()
        .signOut()
        .then(() => {
          localStorage.removeItem("teamConfig");
          // Sign-out successful.
          this.$router.replace("/");
        })
        .catch((error) => {
          // An error happened.
        });
    },

    handleClickMenu(val) {
      if (this.$route.path === "/create-data-entry") {
        this.$swal({
          title: "Are you sure",
          text: "You want to exit the page without saving?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Exit!",
        }).then((result) => {
          if (result.isConfirmed) {
            this.confirmRoute(val);
          }
        });
      } else {
        this.confirmRoute(val);
      }
    },
    confirmRoute(val) {
      if (val === "admin") {
        this.$router.push({ path: "/admin" });
      }

      if (val === "user") {
        this.$router.push({ path: "/user" });
      }

      if (val === "customer") {
        this.$router.push({ path: "/customer" });
      }
      if (val === "team-configuration") {
        this.$router.push({ path: "/team-configuration" });
      }

      if (val === "utilities") {
        const result = localStorage.getItem("teamConfig");
        if (result) {
          this.$router.push({
            path: "/review",
            query: { id: result, view: true, path: "reviewSession" },
          });
        } else {
          this.$router.push({ path: "/utilities" });
        }
      }
    },
  },
};
</script>

<style>
.sidebarOpen {
  left: 0 !important;
}

.sidebarClose {
  left: -300 !important;
}
</style>
